import { useEffect } from 'react'
import { __BoardFilterFields } from '../../common/Dictionaries';
import moment from 'moment';
import { isDateExpired, isDateOnTime, isNullUndefinedOrEmpty, setBoardFieldDisplay } from '../../common/Helpers';
import { cloneDeep } from 'lodash-es';

const useOrderData = (objHomeStadisticData, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                setFireOrderData(false)
                let aux_objHomeStadisticData = null;
                switch (selectedStadisticCard.type) {
                    case "isTotalMessage":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.total_messages - a.total_messages));

                        break;
                    case "isReceived":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.received_messages - a.received_messages));

                        break;
                    case "isSent":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.sent_messages - a.sent_messages));

                        break;
                    case "isUnread":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.unread_message - a.unread_message));

                        break;
                    case "isPending":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.pending_messages - a.pending_messages));

                        break;
                    case "isExpired":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.expired_message - a.expired_message));

                        break;
                    case "isPendingWaiting":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.pending_waiting_message - a.pending_waiting_message));

                        break;
                    case "isExpiredWaiting":
                        aux_objHomeStadisticData = objHomeStadisticData.sort((a,b)=> (b.expired_waiting_message - a.expired_waiting_message));

                        break;   
                    default:
                        break;
                }

                setObjHomeStadisticData(prevState => ({
                    ...prevState,
                    data: aux_objHomeStadisticData,
                    fireUpdate: true
                }));
            }
            catch (error) {
            }
        }
        
        if (objHomeStadisticData !== null && selectedStadisticCard !== null && fireOrderData === true) {
            getData()
        }
    }, [objHomeStadisticData, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData]);
}

const useOrderDataKpi = (objHomeStadisticData, objHomeBoardStadisticData, objHomeKpiStadisticData, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                setFireOrderData(false)
                let aux_objHomeStadisticData = null;

                objHomeBoardStadisticData.map(function(item) {
                    item.type = "Board";
                    return item
                });
                objHomeKpiStadisticData.map(function(item) {
                    item.type = "Gap";
                    return item
                });

                
                aux_objHomeStadisticData = objHomeBoardStadisticData.concat(objHomeKpiStadisticData);

                setObjHomeStadisticData(prevState => ({
                    ...prevState,
                    data: aux_objHomeStadisticData,
                    fireUpdate: true
                }));
            }
            catch (error) {
            }
        }
        
        if (objHomeStadisticData === null && objHomeBoardStadisticData !== null && objHomeKpiStadisticData !== null) {
            getData()
        }
    }, [objHomeStadisticData, objHomeBoardStadisticData, objHomeKpiStadisticData, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData]);
}

const useSortActionComponentData = (list, setList, sortDesc, fire, setFire) => {    
    useEffect(()=> {
        const getData = async () => {
            list.data = list.data.sort((a, b) => {
                const dateA = moment(a.beginDate).toDate();
                const dateB = moment(b.beginDate).toDate();
            
                if (sortDesc === false) {
                    return dateA - dateB;
                } else if (sortDesc === true) {
                    return dateB - dateA;
                } else {
                    return 0;
                }
            });

            setFire(false)

            setList(prevState => ({
                ...prevState,
                data: list.data,
                fireUpdate: true
            }));
        }
        
        if (list !== null && fire === true) {
            getData()
        }
    }, [list, setList, sortDesc, fire, setFire]);
}

const useFilterActionComponentData = (listBase, setListFiltred, filterType, fireMyActions, fire, setFire, userName) => {    
    useEffect(()=> {
        const getData = async () => {
            let auxList = null;

            switch (filterType) {
                case 'isTotal':
                    auxList = listBase.data;
                    break;
                case 'isAccomplished':
                    auxList = listBase.data.filter(x => x.statusId === 4)
                    break;
                case 'isCommitted':
                    auxList = listBase.data.filter(x => x.statusId === 2 && !isNullUndefinedOrEmpty(x.endDate) ? isDateOnTime(x.endDate) : false)
                    break;
                case 'isExpired':
                    auxList = listBase.data.filter(x => (x.statusId === 2 || x.statusId === 3) && !isNullUndefinedOrEmpty(x.endDate) ? isDateExpired(x.endDate) : false)
                    break;
            }

            if (fireMyActions) {
                auxList = listBase.data.filter(x => x.owner === userName.split('\\')[1])
            }

            setFire(false)

            setListFiltred(prevState => ({
                ...prevState,
                data: auxList,
                fireUpdate: true
            }));
        }
        
        if (fire === true) {
            getData()
        }
    }, [listBase, setListFiltred, filterType, fireMyActions, fire, setFire, userName]);
}

const useManipulateFilterFields = (keysMenuOptions, setKeysMenuOptions, storagedFields, calendarSelectorId, periodStartDate, periodEndsDate) => {    
    useEffect(()=> {
        const getData = async () => {
            let aux_field = cloneDeep(__BoardFilterFields);
            let needUpdateSessionCheckedFields = false;

            aux_field.forEach(element => {
                let elementFound = storagedFields.find(x => x.field === element.field);
                
                element.isChecked = elementFound === undefined ? false : true;

                if ((element.field === "serieTime") && (calendarSelectorId === 3 || (calendarSelectorId === 9 && (periodStartDate.getMonth() === periodEndsDate.getMonth() && periodStartDate.getYear() === periodEndsDate.getYear())))){
                    element.enabled = true;
                }
                else if (element.field === "serieTime") {
                    element.enabled = false;
                    element.isChecked = true;
                    needUpdateSessionCheckedFields = true;
                }
            });

            if (needUpdateSessionCheckedFields === true) {
                let newValues = aux_field.filter(x => x.isChecked).map(({ field, simbol }) => ({ field: field, simbol: simbol}));
                setBoardFieldDisplay(newValues)
            }

            setKeysMenuOptions && setKeysMenuOptions(aux_field)
        }
        
        if (keysMenuOptions === null) {
            getData()
        }
    }, [keysMenuOptions, setKeysMenuOptions, storagedFields, calendarSelectorId, periodStartDate, periodEndsDate]);
}

export {
    useOrderData,
    useOrderDataKpi,
    useManipulateFilterFields,
    useSortActionComponentData,
    useFilterActionComponentData
}